import React, {useState} from 'react'

import { useTime } from 'hooks/useTime';
import { VERSION } from '../constants';
import { footerImg} from '../images';
import 'styles/footer.css';
import {Modal} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
export const Footer = () => {

  const [show, setShow] = useState(false);
  const time = useTime();
  const navigate = useNavigate();
  const isImpaired = useSelector((state) => state.layout.isImpaired)

    const handleClickIzjava = () => {
        navigate('/izjava-pristupacnosti'); // Navigiraj na rutu izjava-pristupacnosti
    };

    const handleToggleModal = () => {
    setShow(!show)
  }

  return (
    <>
      <div className="footer-image-wraper">
          <img alt={"Europski socijalni fond"} className="footer-image" src={`${footerImg}`}/>
      </div>
        <div className="footer container-fluid">
            <p className={isImpaired ? "footer-text-disability" : "footer-text"}>© {new Date().getFullYear()}. FINA</p>
            <p className={isImpaired ? "footer-text-disability" : "footer-text"}>Verzija: {VERSION}</p>
            <p>
                <button onClick={handleToggleModal} className={isImpaired ? "button-disability" : "button"}>Korisnička podrška</button>
                <button onClick={handleClickIzjava} className={isImpaired ? "button-disability" : "button"}>Izjava o pristupačnosti</button>
            </p>
            <p className={`footer-end ${isImpaired ? `footer-text-disability` : `footer-text`}`}>{time}</p>
      </div>


      <Modal 
        dialogClassName={isImpaired ? "modal-disability" : ""}
        centered size='lg' show={show} onHide={handleToggleModal}>
        <Modal.Header closeButton>
          <Modal.Title className={isImpaired ? "" : "text-danger"}>
            Podrška za e-Pristojbe
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={isImpaired ?"" :'text-secondary'}>
          <p>e-mail: podrska.epristojbe@fina.hr</p>
          <p>Telefon: 072 200027</p>
          <p>Radno vrijeme telefonske podrške za korisnike: radnim danom od 07:30h do 15:30h</p>
        </Modal.Body>
      </Modal>
    </>
  )
}